import { ACTIONS, HP_VIEWPORT_FLIP, HP_VIEWPORT_ALIGNMENT } from "../../../constants/Constants"

export const initialValues = (action, hpData) => {
  const studyPrerequisiteList = [];
  const viewportList = [];
  if(action === ACTIONS.EDIT || action === ACTIONS.VIEW)  {
    hpData?.studyPrerequisiteList?.forEach((studyPrerequisite) => {
      studyPrerequisiteList.push(
        {
          tag: studyPrerequisite.tag,
          tagValue: studyPrerequisite.tagValue,
          operand: studyPrerequisite.operand,
          operandValue: studyPrerequisite.operandValue,
          value: studyPrerequisite.value
        });
    });
    hpData?.layout?.viewportList?.forEach((viewport) => {
      const seriesConditions = [];
      const imageConditions = [];
      viewport.seriesConditions?.forEach((seriesCondition) => {
        seriesConditions.push({
          tag: seriesCondition.tag,
          tagValue: seriesCondition.tagValue,  
          operand: seriesCondition.operand,
          operandValue: seriesCondition.operandValue,
          value: Array.isArray(seriesCondition.value) 
           ? seriesCondition.value 
           : [seriesCondition.value]});
      });    
      viewport.imageConditions?.forEach((imageCondition) => {
        imageConditions.push({
          tag: imageCondition.tag, 
          tagValue: imageCondition.tagValue,
          operand: imageCondition.operand, 
          operandValue: imageCondition.operandValue,
          value: Array.isArray(imageCondition.value) 
           ? imageCondition.value 
           : [imageCondition.value]});
      });


      viewportList.push(
        {
          row: viewport.row, 
          column: viewport.column, 
          windowWidth: viewport.windowWidth, 
          windowLevel: viewport.windowLevel, 
          flipVertically: viewport.flipVertically,
          flipVerticallyValue: viewport.flipVerticallyValue, 
          flipHorizontally: viewport.flipHorizontally,
          flipHorizontallyValue: viewport.flipHorizontallyValue, 
          alignment: viewport.alignment, 
          alignmentValue: viewport.alignmentValue, 
          rotation:  viewport.rotation ?? "0",
          seriesConditions: seriesConditions,
          imageConditions: imageConditions, 
        });
    
    });

  }
  return (
      (action === ACTIONS.EDIT || action === ACTIONS.VIEW) ? 
      {
        id: hpData?.id,
        name: hpData?.name,
        description: hpData?.description,
        studyPrerequisiteList: studyPrerequisiteList,
        layout: {
          name: hpData?.layout?.name,
          rows: hpData?.layout?.rows,
          columns: hpData?.layout?.columns,
          viewportList: viewportList,
        }
      } : 
      {
        name: "",
        description: "",
        studyPrerequisiteList: [
          { tag: "", operand: "", value: "" },
        ],
        layout: {
          name: "",
          rows: "1",
          columns: "1",
          viewportList: [
            { 
              row: "1",
              column: "1",
              windowWidth: "",
              windowLevel: "",
              flipVertically: HP_VIEWPORT_FLIP.DISABLE,
              flipHorizontally: HP_VIEWPORT_FLIP.DISABLE,
              alignment: HP_VIEWPORT_ALIGNMENT.CENTER,
              rotation: "0",
              seriesConditions: [
                { tag: "", operand: "", value: [] },
              ],
              imageConditions: [
                { tag: "", operand: "", value: [] },
              ],
            }
          ]
        }

      }
    );
}

export const addTabStatusInitialValue = {
  tab1Status: { value: "Info", color: "#FF9900" },
  tab2Status: { value: "Info", color: "#FF9900" },
  tab3Status: { value: "Info", color: "#FF9900" },
  
};

export const editTabStatusInitialValue = {
  tab1Status: { value: "Completed", color: "green" },
  tab2Status: { value: "Completed", color: "green" },
  tab3Status: { value: "Completed", color: "green" },
};

export const setErrorTabStatus = (tabStatusInitialValue, tab) => {
  const newStatus = { ...tabStatusInitialValue };
  newStatus[tab] = { value: "Info", color: "red" };
  return newStatus;
};

export const setValidTabStatus = (tabStatusInitialValue, tab) => {
  const newStatus = { ...tabStatusInitialValue };
  newStatus[tab] = { value: "Completed", color: "green" };
  return newStatus;
};